exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  border-bottom: 1px solid #dddddd;\n  background: #ffffff;\n}\n\n.navbar-brand {\n  padding: 5px 15px;\n}\n\n.navbar-header {\n  margin-left: 20px;\n}\n\n.navbar .container-fluid  ul {\n  margin-left: 50px;\n}\n\n.mea-menu {\n  display: table;\n  height: 50px;\n}\n\n.active {\n  border-bottom: 4px solid #377cad;\n}\n\n.active a {\n  color : #000000;\n  padding-bottom: 11px;\n}\n\nli a {\n  color: #999999;\n}\n\nli a:hover {\n  background: #ffffff;\n}\n\nli a:focus {\n  background: #ffffff;\n}\n\n.logo {\n  display: table-cell;\n  vertical-align: middle;\n  height: 40px;\n}\n\nrouter-outlet {\n  display: inline-block;\n  margin-top: 50px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/app-component/app.component.css
// module id = ../../../../../src/app/components/app-component/app.component.css
// module chunks = main